import { PaymentMethod } from '@ankor-io/common/types/transaction/transaction'

export const getPaymentMethodText = (paymentMethod: PaymentMethod): string => {
  switch (paymentMethod) {
    case PaymentMethod.ANKOR_PAY:
      return 'AnkorPay'
    case PaymentMethod.BOAT_CASH:
      return 'Boat Cash'
    case PaymentMethod.BOAT_STOCK:
      return 'Boat Stock'
    case PaymentMethod.BOAT_APA_CARD:
      return 'Boat APA Card'
    case PaymentMethod.PERSONAL_CASH_OR_CARD:
      return 'Personal Cash or Card'
    case PaymentMethod.TRANSFER:
      return 'Transfer'
    case PaymentMethod.OTHER:
      return 'Other'
    default:
      return paymentMethod
  }
}
